import React, { useRef } from 'react';
import cssVariables from '../../styles/variables.scss';
import { useItemsInView } from '../../utils/useItemsInView';
import InfiniteList from './items/InfiniteList';
import { scrollToRow } from '../../utils/scrollToRow';
import { TABLE_WIDGET_ROW_HEIGHT } from '../../utils/gridHelpers';
import TextRow from './items/TextRow';
const NAVBAR_HEIGHT = parseInt(cssVariables.navbarHeight, 10);
export default function DescriptiveTableWidget(props) {
    const callbackRef = useItemsInView(props.onViewed);
    const scrollToIndex = props.data.items.findIndex((item) => item.shouldScrollTo);
    const containerRef = useRef(null);
    scrollToRow(!!props.canScroll, scrollToIndex, TABLE_WIDGET_ROW_HEIGHT, containerRef, NAVBAR_HEIGHT * -1);
    return (React.createElement("div", { ref: containerRef },
        React.createElement(InfiniteList, { data: props.data, handleSelected: props.handleSelected, componentType: TextRow, rowHeight: TABLE_WIDGET_ROW_HEIGHT, isTextRow: true, itemsViewedRef: callbackRef, scrollToIndex: scrollToIndex })));
}
